import { createBrowserHistory } from "history";
import { Router } from "react-router-dom";
import AuthState from "./context/Auth/authState";
// import AlertState from './component/context/other/AlertState';
import DashboardRoute from "./Routes/Routes";
import ThemeConfig from "./theme";
import { SnackbarProvider } from "notistack";
import Slide from "@material-ui/core/Slide";
import FetchAPIState from "./context/fetchData/fetchDataState";

import "./app.scss";
const history = createBrowserHistory();

function App() {
	return (
		<ThemeConfig>
			<SnackbarProvider
				anchorOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
				TransitionComponent={Slide}
				maxSnack={1}
			>
				<AuthState>
					<FetchAPIState>
						<Router history={history}>
							<DashboardRoute />
						</Router>
					</FetchAPIState>
				</AuthState>
			</SnackbarProvider>
		</ThemeConfig>
	);
}

export default App;
